import { render } from "./PurchaseOrderApprovalList.vue?vue&type=template&id=657636a6&scoped=true"
import script from "./PurchaseOrderApprovalList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderApprovalList.vue?vue&type=script&lang=js"

import "./PurchaseOrderApprovalList.vue?vue&type=style&index=0&id=657636a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657636a6"]])

export default __exports__